<template>
    <v-layout justify-center>
        <v-responsive max-width="1080" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading :title="banner._id ? '배너 상세보기' : '배너 등록'" />

            <v-row class="mx-n2">
                <v-col cols="12" sm="4" class="pa-2">
                    <v-card outlined class="pa-3">
                        <v-text-field v-model="banner.name" label="이름" v-bind="attrs_input" />
                    </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pa-2">
                    <v-card outlined class="pa-3">
                        <v-text-field v-model="banner.code" label="코드" v-bind="attrs_input" />
                    </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pa-2">
                    <v-card outlined class="pa-3">
                        <v-text-field label="영역 노출" :value="banner.shows ? '노출' : '미노출'" readonly class="switch-field" v-bind="attrs_input" @click="banner.shows = !banner.shows">
                            <template #prepend-inner>
                                <v-switch v-model="banner.shows" dense v-bind="attrs_switch" class="ma-0 ml-1" />
                            </template>
                        </v-text-field>
                    </v-card>
                </v-col>
                <v-col cols="12" md="" class="pa-2">
                    <v-card outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">슬라이드</v-card-title>
                        <v-divider />
                        <draggable v-model="banner.slides">
                            <transition-group>
                                <v-sheet v-for="(slide, index) in banner.slides" :key="`${index}`">
                                    <v-list-item>
                                        <v-list-item-action class="pa-0 ma-0 mr-4">
                                            <v-preview-input v-model="slide.image" min-width="96" min-height="96" max-width="96" max-height="96" contain></v-preview-input>
                                        </v-list-item-action>
                                        <v-divider vertical />
                                        <v-list-item-content class="pa-2">
                                            <v-row class="ma-0" align="center">
                                                <v-col cols="12" md="6" lg="5" class="pa-2">
                                                    <v-text-field v-model="slide.url" label="URL" v-bind="attrs_input" />
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5" class="pa-2">
                                                    <v-select label="링크 유형" v-model="slide.target" :items="targets" v-bind="attrs_input" />
                                                </v-col>
                                                <v-col class="d-none d-lg-block" />
                                                <v-col cols="12" md="6" lg="5" class="pa-2">
                                                    <v-datetime-field v-model="slide.showsStartsAt" label="노출시작일시" clearable v-bind="attrs_input" />
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5" class="pa-2">
                                                    <v-datetime-field v-model="slide.showsEndsAt" label="노출종료일시" clearable v-bind="attrs_input" />
                                                </v-col>
                                                <v-col cols="12" md="6" lg="" class="pa-2">
                                                    <v-switch v-model="slide.shows" dense v-bind="attrs_switch" class="ma-0 ml-1">
                                                        <template #label> {{ slide.shows ? "노출" : "미노출" }} </template>
                                                    </v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                        <v-divider vertical />
                                        <v-list-item-action>
                                            <v-icon @click="banner.slides.splice(index, 1)">mdi-delete</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider v-if="index !== banner.slides.length - 1" />
                                </v-sheet>
                            </transition-group>
                        </draggable>
                    </v-card>

                    <v-card flat class="mt-4">
                        <v-file-btn outlined color="blue" width="100%" multiple accept="image/*" @change="upload">
                            <v-icon class="mr-2"> mdi-cloud-upload </v-icon>
                            <span>배너 이미지 업로드</span>
                        </v-file-btn>
                    </v-card>
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-4">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch } from "@/assets/variables";

import VFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
import Draggable from "vuedraggable";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import VPreviewInput from "@/components/plugins/vuetify/v-preview-input.vue";
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";

const targets = [
    { text: "지금 창에서 열기", value: null },
    { text: "새로운 창에서 열기", value: "_blank" },
];

export default {
    components: {
        VFileBtn,
        Draggable,
        ListHeading,
        VPreviewInput,
        VDatetimeField,
    },
    data: () => ({
        targets,
        attrs_input,
        attrs_switch,

        images: null,

        banner: {
            _id: undefined,

            name: null,
            code: null,
            locale: "ko",
            slides: [],
            shows: false,
        },

        closedAt: null,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.$route.params._banner) {
                var { banner } = await api.console.banners.get({ _id: this.$route.params._banner });

                for (let index in banner.slides) {
                    if (banner.slides[index].image) banner.slides[index].image = await api.getResource(banner.slides[index].image);
                }

                this.banner = { ...this.banner, ...banner };
            }

            if (!this.banner.slides.length) {
                this.banner.slides = [...this.banner.slides, { image: null, url: null, meta: {} }];
            }
        },

        validate() {
            try {
                if (!this.banner.name) throw new Error("배너 명칭을 입력해주세요");
                if (!this.banner.code) throw new Error("배너 코드를 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                let { banner } = this.banner._id ? await api.console.banners.put(this.banner) : await api.console.banners.post(this.banner);

                for (let index in this.banner.slides) {
                    if (this.banner.slides[index]) await api.console.banners.images.post(banner._id, index, this.banner.slides[index].image);
                }

                alert("저장되었습니다");
                this.$router.push(`/console/banners`);
            }
        },

        upload(files) {
            this.banner.slides = [
                ...files.map((file) => ({
                    image: file,
                    url: null,
                    target: null,
                    meta: {},

                    shows: false,
                    showsEndsAt: null,
                    showsStartsAt: null,
                })),
                ...this.banner.slides,
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .editor.hidden {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
    }

    .switch-field {
        input {
            cursor: pointer;
        }
    }
}
</style>
